import styled from "styled-components";
import { useParams } from "react-router-dom";
import SideBar from "../../../../components/Sidebar";
import MainSystemSettings from "./MainSystemSettings";
import EmailSystemSettings from "./EmailSystemSettings";
import SuspenseAccountsSettings from "./SuspenseAccountsSettings";
import LoginSettings from "./LoginSettings";
import { useEffect } from "react";

const StyledSystemSettings = styled.div`
    display: flex;
`;

function SystemSettings(props) {

    let defaultPath = '/settings/system/';

    let defaultPagePath = 'mainsystem';
    let {subPagePath} = useParams();

    let items = [
        {text: 'Main system', path: 'mainsystem'},
        {text: 'Email settings', path: 'emailsettings'},
        {text: 'Suspense accounts', path: 'suspenseaccounts'},
        {text: 'Login details', path: 'loginsettings'}
    ];

    let loadedPage = false;
    useEffect(() => {
        if (!loadedPage) {
            loadedPage = true;
            props.setSmallPageTitle('');
        }
    });

    return (
        <StyledSystemSettings>
            <SideBar title={'Settings'} items={items} defaultPath={defaultPath} selectedSubPagePath={subPagePath ? subPagePath : defaultPagePath} {...props}></SideBar>
            {(!subPagePath || subPagePath === '' || subPagePath === 'mainsystem') && <MainSystemSettings {...props}></MainSystemSettings>}
            {subPagePath === 'emailsettings' && <EmailSystemSettings {...props}></EmailSystemSettings>}
            {subPagePath === 'suspenseaccounts' && <SuspenseAccountsSettings {...props}></SuspenseAccountsSettings>}
            {subPagePath === 'loginsettings' && <LoginSettings {...props}></LoginSettings>}
        </StyledSystemSettings>
    )
}

export default SystemSettings;